<template>
	<v-container>
	  <v-row justify="center">
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" class="pb-1">
	  		<v-card class="elevation-0 transparent">
	  			<v-card-text>
						<div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              e-Books
            </div>
	  			</v-card-text>
	  		</v-card>
	  	</v-col>

	  	<v-col cols="12" md="10" lg="8">
		    <v-expansion-panels class="shadowCard px-0">
		      <v-expansion-panel v-for="(pdf, i) in getRecurso" :key="i" class="px-0">
		        <v-expansion-panel-header disable-icon-rotate>
		        	<!-- Titulo -->
		          <v-list-item class="px-2">
				        <v-list-item-content>
				          <v-list-item-title>
					  		    <v-btn icon @click="descargarPdf( pdf.ruta )" class="mr-2"><v-icon>mdi-download</v-icon></v-btn>
				            <span class="grey--text">{{ pdf.recurso }}</span>
					  		    <v-spacer></v-spacer>
				          </v-list-item-title>
				        </v-list-item-content>
				      </v-list-item>

				      <!-- Estatus -->
		          <template v-slot:actions>
			          <v-card 
	        				width="42" height="42" class="elevation-0 transparent">
									<v-img src="@/assets/iconos/pdf.svg" ></v-img>
								</v-card>
		          </template>

		        </v-expansion-panel-header>

		        <!-- Panel informativo -->
		        <v-expansion-panel-content class="px-0">
		        	<v-divider></v-divider>
		        	<v-card-actions class="px-0">
		        		<embed :src="`${url}viewer/web/viewer.html?file=${url}${pdf.ruta}`" width="100%" height="500px" >
		        	</v-card-actions>
		        </v-expansion-panel-content>

		      </v-expansion-panel>
		    </v-expansion-panels>
	  	</v-col>
	  </v-row>

	  <v-speed-dial
      top
      left
      fixed
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          fab
          @click="verRecursos()"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

    <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'


	export default {
	  name: "dashboard-default",
	  data: () => ({
	  	url: '',
	  	show: false,

	  	loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
     	respuestaAlerta: false,
	  }),

	  components: {
	    Alerta,
	    Loader
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getRecurso' ])
	  },

	  created(){
	  	if(this.getRecursosGrupoUsuario.length > 0){
	  		this.url = this.getRecursosGrupoUsuario[0].ubicacion
	  	}
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirVentanaRecurso'] ),
	  	descargarPdf( ruta ){
	  		window.open(`${this.url}${ruta}`)
	  	},

	  	verRecursos ( ){
	  		this.cargar = true
	  		const payload = {
					id_usuario: this.getUsuarioLMS.id, 
					id_curso:   this.getGrupo.grupo.id_curso,
					id_nivel:   this.getGrupo.grupo.id_nivel,
					id_grupo:   this.getGrupo.grupo.id,
					lecciones:  this.getGrupo.info_curso.dias_clase,
					tipo:       this.getGrupo.grupo.tipo
	  		}

	  		this.abrirRecursosAlumno( payload ).then(response => { 
	  			this.cargar = false
	  		}).catch( error =>{
    			this.validarErrores ( error )
    		}).finally( () => { this.cargar = false })
	  	},

	  	validarErrores ( value ){
	  		this.cargar = false
  			if( value.status == 400 || value.status == 500 ){
    			this.parametros.mensaje = value.body.message
  				this.parametros.color        = '#FF2C2C'
    			this.parametros.dialogError  = true 
    			this.respuestaAlerta = true 
    		}
	  	}
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}
	
	.colorCurso{
		color: #006093;
	}

	.v-expansion-panel-content__wrap{
		padding-right: 0px !important;
		padding-left: 0px !important;
	}
</style>
